import { authReduxService } from '@/lib/auth-redux-service';
import { AppDispatch, RootState } from '@/store';
import {
  clearSession,
  initializeAuth,
  setLoading,
  setUser,
} from '@/store/slices/authSlice';
import { useDispatch, useSelector } from 'react-redux';

// Import User type from auth slice
type User = RootState['auth']['user'];

export const useAuthRedux = () => {
  const dispatch = useDispatch<AppDispatch>();
  const auth = useSelector((state: RootState) => state.auth);

  return {
    // State
    user: auth.user,
    isAuthenticated: auth.isAuthenticated,
    loading: auth.loading,

    // Redux Actions
    setUser: (user: User) => dispatch(setUser(user)),

    setLoading: (loading: boolean) => dispatch(setLoading(loading)),

    clearSession: () => dispatch(clearSession()),

    initializeAuth: (authData: Partial<RootState['auth']>) =>
      dispatch(initializeAuth(authData)),

    // Auth Service Methods
    signInWithPhone: authReduxService.signInWithPhone.bind(authReduxService),
    verifyOtp: authReduxService.verifyOtp.bind(authReduxService),
    logout: authReduxService.logout.bind(authReduxService),
    isSupabaseConfigured: authReduxService.isConfigured,
  };
};
